import DOMPurify from "dompurify";
import "./rich_text.scss";

const FORMATTING_STYLE_CLASSES: Array<[RegExp, string]> = [
  [/text-decoration(?:-line)?\s*:\s*[^;]*\bunderline\b/i, "rich-text-underline"],
  [/text-decoration(?:-line)?\s*:\s*[^;]*\bline-through\b/i, "rich-text-strike"],
];

export const sanitizeRichText = (html: string): string => {
  const clean = DOMPurify.sanitize(html);
  const doc = new DOMParser().parseFromString(clean, "text/html");

  doc.body.querySelectorAll<HTMLElement>("[style]").forEach((node) => {
    const style = node.getAttribute("style") ?? "";
    for (const [pattern, className] of FORMATTING_STYLE_CLASSES) {
      if (pattern.test(style)) node.classList.add(className);
    }
  });

  return doc.body.innerHTML;
};

interface Props {
  html: string;
  className?: string;
}

export const RichText = ({ html, className }: Props) => (
  <div
    className={className ? `rich-text ${className}` : "rich-text"}
    dangerouslySetInnerHTML={{ __html: sanitizeRichText(html) }}
  />
);
